import { createReducer } from "reduxsauce";
import _ from "lodash";

// Commenting out missing action type imports
// import { ActionTypes as AdminActionTypes } from "./actionTypes/layouts/AdminActionTypes";
// import { ActionTypes as RegisterPartnerActionTypes } from "./actionTypes/screens/account/RegisterPartnerActionTypes";
// import { ActionTypes as LoginActionTypes } from "./actionTypes/screens/account/LoginActionTypes";
// import { ActionTypes as UserLoginActionTypes } from "./actionTypes/screens/account/UserLoginActionTypes";
// import { ActionTypes as UserRegisterActionTypes } from "./actionTypes/screens/account/UserRegisterActionTypes";
// import { ActionTypes } from "./actionTypes/SessionActionTypes";

import AppConfig from "../config/AppConfig";
import StorageEngine from "../utils/StorageEngine";
import SessionService from "../services/screens/SessionService";
import Cookies from "universal-cookie";

import { ActionTypes as LoginActionTypes } from "./actionTypes/screens/account/LoginActionTypes";
import { ActionTypes as SSORedirectActionTypes } from "./actionTypes/screens/account/SSORedirectActionTypes";
import { ActionTypes as NewLoginActionTypes } from "./actionTypes/screens/account/OldLoginActionTypes.js";
import { ActionTypes as SchoolSelectionActionTypes } from "./actionTypes/screens/SchoolSelectionActionTypes.js";
import { ActionTypes as PortalActionTypes } from "./actionTypes/layouts/PortalActionTypes.js";
import { ActionTypes as AdminActionTypes } from "./actionTypes/layouts/AdminActionTypes.js";

// Define ActionTypes here since the import is missing
const ActionTypes = {
    TRY_LOAD_SESSION: "TRY_LOAD_SESSION",
    LOGOUT_REQUEST: "LOGOUT_REQUEST",
    LOGOUT_SUCCESS: "LOGOUT_SUCCESS",
    LOGOUT_FAILURE: "LOGOUT_FAILURE",
    RECEIVE_REFRESHED_TOKEN: "RECEIVE_REFRESHED_TOKEN",
    SWITCH_BACK_TO_SUPER_ADMIN: "SWITCH_BACK_TO_SUPER_ADMIN",
    SWITCH_BACK_TO_AGENT: "SWITCH_BACK_TO_AGENT",
    SWITCH_BACK_TO_TEACHER: "SWITCH_BACK_TO_TEACHER",
    CHANGE_NETWORK: "CHANGE_NETWORK",
};

//
// Actions
//
const Actions = {
    tryLoadSession: () => ({
        type: ActionTypes.TRY_LOAD_SESSION,
    }),

    logout: () => (dispatch) => {
        dispatch({ type: ActionTypes.LOGOUT_REQUEST });

        if (window.IS_ELECTRON){
            window.localStorage.setItem("JwtTokenForSPA", "");
            window.localStorage.setItem("iml_primarySchoolId", "");
            window.localStorage.setItem("iml_userId", "");

            window.sharedData.set('iml_primarySchoolId', window.localStorage.getItem('iml_primarySchoolId'));
            window.sharedData.set('iml_userId', window.localStorage.getItem('iml_userId'));
            window.sharedData.set('JwtTokenForSPA', window.localStorage.getItem('JwtTokenForSPA'));
            window.sharedData.set('accessToken', "");
            window.sharedData.set('refreshToken', "");

            dispatch({ type: ActionTypes.LOGOUT_SUCCESS, data: {} });
        } else {
            SessionService.logout(
                (response) => {
                    // Success callback
                    dispatch({ type: ActionTypes.LOGOUT_SUCCESS, data: response });
                },
                (error) => {
                    // Failure callback
                    dispatch({ type: ActionTypes.LOGOUT_FAILURE, error });
                }
            );
        }

    },

    receiveRefreshedToken: (data) => ({
        type: ActionTypes.RECEIVE_REFRESHED_TOKEN,
        data,
    }),

    switchBackToSuperAdmin: (data) => ({
        type: ActionTypes.SWITCH_BACK_TO_SUPER_ADMIN,
        data,
    }),
    changeNetwork: ({currentSchoolId, shortId}) => ({
        type: ActionTypes.CHANGE_NETWORK,
        currentSchoolId,
        shortId,
    }),
};

/* ------------- Initial State ------------- */
const INITIAL_STATE = {
    // Current school id
    currentSchoolId: null,
    // Short id shown in URL
    shortId: null,
    // Subdomain identifier (may differ from shortId)
    customDomain: null,
    // UserOutVO fields
    userId: null,
    isAdminInAnyNetwork: false,
    isOfficialCanEditInAnyNetwork: false,
    authorization: null,

    // LoginDoneOutVO fields
    ssoSchoolId: null,
    mainNavigColor: null,
    showAds: false,
    isSignalRConversationEnabled: false,
    isAdFree: false,
    adFreeSemesterFee: 0,
    hideAdFreeFee: false,
    hideRemoveAdsLinkInAppOnly: false,
    primarySchoolId: null,

    // Logout state
    isLoggingOut: false,
    logoutError: null,
};

/* ------------- Reducers ------------- */
// we've successfully logged in
const loginSuccessReducer = (state, { data }) => {
    const baseState = {
        // UserOutVO fields
        userId: data.userId,
        isAdminInAnyNetwork: data.isAdminInAnyNetwork,
        isOfficialCanEditInAnyNetwork: data.isOfficialCanEditInAnyNetwork,
        authorization: data.authorization,

        // LoginDoneOutVO fields
        ssoSchoolId: data.ssoSchoolId,
        mainNavigColor: data.mainNavigColor,
        showAds: data.showAds,
        isSignalRConversationEnabled: data.isSignalRConversationEnabled,
        isAdFree: data.isAdFree,
        adFreeSemesterFee: data.adFreeSemesterFee,
        hideAdFreeFee: data.hideAdFreeFee,
        hideRemoveAdsLinkInAppOnly: data.hideRemoveAdsLinkInAppOnly,
        primarySchoolId: data.primarySchoolId,
        currentSchoolId: data.primarySchoolId,
    };

    // Save to storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save(baseState);

    return { ...state, ...baseState };
};
const spaLoginSuccessReducer= (state, { data }) => {
    const response = data;
    const baseState = {
        // UserOutVO fields
        userId: response.data.userId,
        isAdminInAnyNetwork: response.data.isAdminInAnyNetwork,
        isOfficialCanEditInAnyNetwork: response.data.isOfficialCanEditInAnyNetwork,
        authorization: response.data.authorization,

        // LoginDoneOutVO fields
        ssoSchoolId: response.data.ssoSchoolId,
        mainNavigColor: response.data.mainNavigColor,
        showAds: response.data.showAds,
        isSignalRConversationEnabled: response.data.isSignalRConversationEnabled,
        isAdFree: response.data.isAdFree,
        adFreeSemesterFee: response.data.adFreeSemesterFee,
        hideAdFreeFee: response.data.hideAdFreeFee,
        hideRemoveAdsLinkInAppOnly: response.data.hideRemoveAdsLinkInAppOnly,
        primarySchoolId: response.data.primarySchoolId,
        currentSchoolId: response.data.primarySchoolId,
        shortId: response.data.primarySchoolShortId,
    };

    // Save to storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save(baseState);

    return { ...state, ...baseState };
};
const logoutRequestReducer = (state) => {
    // Set loading state when logout request starts
    return { ...state, isLoggingOut: true };
};

const logoutSuccessReducer = (state) => {
    // Delete from store
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).delete();
    const cookies = new Cookies();
    // Clear cookie and complete logout process
    cookies.remove("ApiTokenForSPA" , {
        path: "/",
    });

    cookies.remove("ApiRefreshTokenForSPA", {
        path: "/",
    });
    // We need to keep some values like isConnected or else, so
    // here we only override necessary states when logout
    return { ...state, ...INITIAL_STATE, isLoggingOut: false };
};

const logoutFailureReducer = (state, { error }) => {
    // Handle logout failure - keep user logged in but clear loading state
    console.error('Logout failed:', error);
    // Delete from store
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).delete();
    const cookies = new Cookies();
    // Clear cookie and complete logout process
    cookies.remove("ApiTokenForSPA" , {
        path: "/",
    });

    cookies.remove("ApiRefreshTokenForSPA", {
        path: "/",
    });
    return { ...state,...INITIAL_STATE, isLoggingOut: false, logoutError: error };
};

const tryLoadSessionReducer = (state) => {
    // Load state from SESSION_STORAGE_KEY and LAST_VISITED_NETWORK_ID_KEY
    const sessionState = StorageEngine(AppConfig.SESSION_STORAGE_KEY).load();
    const networkState = StorageEngine(AppConfig.LAST_VISITED_NETWORK_ID_KEY).load();

    // If we came from the SPA, cookies should contain the latest token. Use it to avoid login failures caused by missing/expired tokens.
    const cookies = new Cookies();
    const apiTokenForSPA = cookies.get("ApiTokenForSPA");
    const apiRefreshTokenForSPA = cookies.get("ApiRefreshTokenForSPA");
    if (apiTokenForSPA && apiRefreshTokenForSPA) {
        sessionState.authorization = {
            accessToken: apiTokenForSPA,
            refreshToken: apiRefreshTokenForSPA,
        };
    }
    // Sync data to Electron
    if (window.IS_ELECTRON) {
        if (sessionState.authorization) {
            window.sharedData.set('accessToken', sessionState.authorization.accessToken);
            window.sharedData.set('refreshToken', sessionState.authorization.refreshToken);
        }else{
            window.sharedData.set('accessToken', '');
            window.sharedData.set('refreshToken', '');
        }

        window.sharedData.set('iml_userId', sessionState.userId);
    }

    if (sessionState) {
        // Merge session state; if networkState exists, override network id
        if (networkState) {
            return {
                ...state,
                ...sessionState,
                currentSchoolId: networkState.currentSchoolId,
                shortId: networkState.shortId,
                customDomain: networkState.customDomain
            };
        }
        return { ...state, ...sessionState };
    } else if (networkState) {
        // Restore network state
        return {
            ...state,
            currentSchoolId: networkState.currentSchoolId,
            shortId: networkState.shortId,
            customDomain: networkState.customDomain
        };
    }
    return state;
};


const receiveRefreshedTokenReducer = (state, { data }) => {
    const newState = {
        authorization: { ...data },
    };

    //save into storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const switchBackToSuperAdminReducer = (state, { data }) => {
    const newState = {
        ...data,
        user: data.user,
        userId: data.userId,
        authorization: data.authorization,
        superAdmin: true,
        isLoginFromSuperAdmin: false,
        isLoginFromAgent: false,
        isLoginFromAdminStatic: false,
        isLoginFromTeacher: false,
    };
    //save into storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const switchBackToAgentReducer = (state, { data, isLoginFromAdminStatic, superAdminBackupData }) => {
    const newState = {
        ...data,
        user: data.user,
        userId: data.userId,
        authorization: data.authorization,
        superAdmin: true,
        isLoginFromAgent: false,
        isLoginFromAdminStatic,
        superAdminBackupData,
        isLoginFromTeacher: false,
    };
    //save into storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const switchBackToTeacherReducer = (state, { data, isLoginFromAdminStatic, superAdminBackupData, isLoginFromAgent, agentBackupData }) => {
    const newState = {
        ...data,
        user: data.user,
        userId: data.userId,
        authorization: data.authorization,
        superAdmin: true,
        isLoginFromAgent,
        isLoginFromAdminStatic,
        superAdminBackupData,
        agentBackupData,
        isLoginFromTeacher: false,
    };

    //save into storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const changeNetworkReducer = (state, { currentSchoolId, shortId, customDomain }) => {
    // Persist long id, short id, and custom domain
    StorageEngine(AppConfig.LAST_VISITED_NETWORK_ID_KEY).save({ currentSchoolId, shortId, customDomain });

    // Update Redux store state
    const newState = { currentSchoolId, shortId, customDomain };
    return { ...state, ...newState };
};

const selectSchoolReducer = (state, { school }) => {
    // Persist long id, short id, and custom domain
    StorageEngine(AppConfig.LAST_VISITED_NETWORK_ID_KEY).save({
        currentSchoolId: school.id,
        shortId: school.idValue,
        customDomain: school.customDomain
    });

    // Update Redux store state
    const newState = {
        currentSchoolId: school.id,
        shortId: school.idValue,
        customDomain: school.customDomain
    };
    return { ...state, ...newState };
};

const layoutLoadSchoolSuccessReducer = (state, { data }) => {
    // Extract school information from layout's LOAD_SCREEN_VIEW_SUCCESS response
    const networkItem = data?.layoutVo?.networkItem;
    if (!networkItem) {
        return state;
    }

    // Update session state with school information from layout response
    const newState = {
        currentSchoolId: networkItem.id,
        shortId: networkItem.idValue,
        customDomain: networkItem.customDomain
    };

    // Also persist to localStorage
    StorageEngine(AppConfig.LAST_VISITED_NETWORK_ID_KEY).save({
        currentSchoolId: networkItem.id,
        shortId: networkItem.idValue,
        customDomain: networkItem.customDomain
    });

    return { ...state, ...newState };
};
/* ------------- Hookup Reducers To Types ------------- */

const reducer = createReducer(INITIAL_STATE, {
    // Commenting out reducers that use missing action types
    // [UserLoginActionTypes.LOGIN_SUCCESS]: loginSuccessReducer,
    // [RegisterPartnerActionTypes.REGISTER_PARTNER_SUCCESS]: loginSuccessReducer,
    // [RegisterPartnerActionTypes.LOGIN_SUCCESS]: loginSuccessReducer,
    // [UserRegisterActionTypes.REGISTER_SUCCESS]: loginSuccessReducer,
    // [UserRegisterActionTypes.LOGIN_SUCCESS]: loginSuccessReducer,
    [SSORedirectActionTypes.SSO_LOGIN_SUCCESS]: loginSuccessReducer,
    [LoginActionTypes.LOGIN_SUCCESS]: window.IS_ELECTRON ? loginSuccessReducer : spaLoginSuccessReducer,
    [NewLoginActionTypes.TEMP_TOKEN_LOGIN_SUCCESS]: loginSuccessReducer,
    //[RegisterPartnerActionTypes.ACTIVE_TEACHER_SUCCESS]: loginSuccessReducer,
    //[AdminActionTypes.SELECT_PARTNER]: selectPartnerSuccessReducer,
    [ActionTypes.TRY_LOAD_SESSION]: tryLoadSessionReducer,
    [ActionTypes.LOGOUT_REQUEST]: logoutRequestReducer,
    [ActionTypes.LOGOUT_SUCCESS]: logoutSuccessReducer,
    [ActionTypes.LOGOUT_FAILURE]: logoutFailureReducer,
    [ActionTypes.RECEIVE_REFRESHED_TOKEN]: receiveRefreshedTokenReducer,
    [ActionTypes.SWITCH_BACK_TO_SUPER_ADMIN]: switchBackToSuperAdminReducer,
    [ActionTypes.SWITCH_BACK_TO_AGENT]: switchBackToAgentReducer,
    [ActionTypes.SWITCH_BACK_TO_TEACHER]: switchBackToTeacherReducer,
    [ActionTypes.CHANGE_NETWORK]: changeNetworkReducer,
    [SchoolSelectionActionTypes.SELECT_SCHOOL]: selectSchoolReducer,

    // Subscribe to layout LOAD_SCREEN_VIEW_SUCCESS to sync school information
    [PortalActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: layoutLoadSchoolSuccessReducer,
    [AdminActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: layoutLoadSchoolSuccessReducer,

    //[LoginActionTypes.CHANGE_PASSWORD_SUCCESS]: loginSuccessReducer,
});

export { ActionTypes, Actions, reducer, INITIAL_STATE };
